const VideoCollection = [
  {
    "id": "100",
    "title": "Video Letter A",
    "src": "videos_letter_a.mp4",
    "duration": "00:01:51.87",
    "durationInMilliseconds": 111087,
  },
  {
    "id": "103",
    "title": "Video Letter D",
    "src": "videos_letter_d.mp4",
    "duration": "00:01:36.02",
    "durationInMilliseconds": 96020,
  },
  {
    "id": "115",
    "title": "Video Letter M",
    "src": "videos_letter_m.mp4",
    "duration": "00:01:25.35",
    "durationInMilliseconds": 85350,
  }
]

export default VideoCollection;
